import { Component, Vue } from 'vue-property-decorator'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

@Component({
  components: { ConfirmDialog }
})
export default class AdminEditMixin extends Vue {
  dialogs: any = {
    confirmRemove: false
  }

  hideConfirmRemoveDialog () {
    this.dialogs.confirmRemove = false
  }

  showConfirmRemoveDialog () {
    this.dialogs.confirmRemove = true
  }
}
